if (!customElements.get("sticky-header")) {
  customElements.define(
    "sticky-header",
    class StickyHeader extends HTMLElement {
      constructor() {
        super();

        this.stickyType = this.getAttribute("data-sticky-type") || "none";
        if (this.stickyType === "none") return;

        this.currentScrollTop = 0;
        this.onScrollHandler = this.onScroll.bind(this);
        this.preventHide = false; // Prevent hiding
        this.preventReveal = false; // Prevent redisplay
        this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      }

      connectedCallback() {
        this.header = document.querySelector(".section-header");
        this.headerIsAlwaysSticky = this.stickyType === "always" || this.stickyType === "reduce-logo-size";
        this.headerBounds = {}; // header container limit
        this.setHeaderHeight();

        window.matchMedia("(min-width: 750px)").addEventListener("change", this.setHeaderHeight.bind(this));

        if (this.headerIsAlwaysSticky) {
          this.header.classList.add("shopify-section-header-sticky");
        }

        this.predictiveSearch = this.querySelector("predictive-search");

        // Initialize the header state of the body.
        document.documentElement.setAttribute("data-header-status", "visible");
        // Add a block to prevent the header from displaying.
        this.addEventListener("preventHeaderReveal", this.hideHeaderOnScrollUp);

        window.addEventListener("scroll", this.onScrollHandler);
        this.createObserver();
      }

      disconnectedCallback() {
        window.removeEventListener("scroll", this.onScrollHandler);
      }

      setHeaderHeight() {
        if (document.documentElement.style.getPropertyValue("--header-height") !== "") return;
        document.documentElement.style.setProperty("--header-height", `${this.header.querySelector("header").offsetHeight}px`);
      }

      /* ====== Monitor the position of the initial page header Regardless of whether the header is visible ====== */
      createObserver() {
        const observer = new IntersectionObserver((entries, observer) => {
          this.headerBounds = entries[0].intersectionRect;
          observer.disconnect();
        });
        observer.observe(this.header);
      }

      onScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        // When page scrolling is disabled or the search modal is opened
        if (document.body.hasAttribute("scroll-y-off") || (this.predictiveSearch && this.predictiveSearch.isOpen)) return;

        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          // Scroll down and the header passes.
          this.header.classList.add("scrolled-past-header");
          if (this.preventHide) return;

          if (!this.headerIsAlwaysSticky) requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          // Scroll up and the header passes.
          this.header.classList.add("scrolled-past-header");
          if (!this.preventReveal) {
            if (!this.headerIsAlwaysSticky) requestAnimationFrame(this.reveal.bind(this));
          } else {
            // Prevent the header from being revealed during the current scroll, then reset `this.preventReveal` to allow the header to be revealed on the next scroll.
            // Debounce effect
            window.clearTimeout(this.isScrolling);
            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 60);

            if (!this.headerIsAlwaysSticky) requestAnimationFrame(this.hide.bind(this));
          }
        } else if (scrollTop <= this.headerBounds.top) {
          this.header.classList.remove("scrolled-past-header");
          if (!this.headerIsAlwaysSticky) requestAnimationFrame(this.reset.bind(this));
        }
        this.currentScrollTop = scrollTop;
      }

      // Hide header
      hide() {
        this.header.classList.add("shopify-section-header-hidden", "shopify-section-header-sticky");
        this.closeDropMenus();
        // Update the header state of the body.
        document.documentElement.setAttribute("data-header-status", "hidden");
      }

      // Show the header again
      reveal() {
        this.header.classList.add("shopify-section-header-sticky", "animate");
        this.header.classList.remove("shopify-section-header-hidden");
        // Update the header state of the body.
        document.documentElement.setAttribute("data-header-status", "visible");
      }

      reset() {
        this.header.classList.remove(
          "shopify-section-header-hidden",
          "shopify-section-header-sticky",
          "animate",
        );
        // Restore the header state of the body.
        document.documentElement.setAttribute("data-header-status", "visible");
      }

      /* ====== Close the open menu ====== */
      closeDropMenus() {
        this.dropMenus = this.dropMenus || this.header.querySelectorAll("drop-menu");
        this.dropMenus.forEach((dropMenu) => dropMenu.close());
      }
    },
  );
}